namespace appn.views.notifications.index {

    class InitArgs {
        hasNoticeItems: boolean = false;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs) {
        _initArgs = args;

        if (!_initArgs.hasNoticeItems) {
            appn.notifications.updateNotificationTotal(true);
            appn.notifications.hideNotificationIcon();
            appn.iframe.closeModal();
        }

        addEvents();
        hideNotificationFooterIfEmpty();
    }

    function addEvents() {

        $('.delete_button').on('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            // Swap delete button and check box
            $(this).hide();
            $(this).closest('.card-tools').find('.select-delete').show();
            $(this).closest('.card-tools').find('.select-delete input').prop('checked', true);

            // Also select children for dismissal
            if ($(this).closest('.notification-parent').length > 0) {
                $(this).closest('.notification-group').find('.select-delete').show();
                $(this).closest('.notification-group').find('.select-delete input').prop('checked', true);
                $(this).closest('.notification-group').find('.delete_button').hide();
            }

            const notificationGroup = $(this).closest('.notification-group');
            if (notificationGroup.length > 0) {
                const selectedCount = notificationGroup.find('.notice .select-delete input:checked').length;
                const childrenCount = notificationGroup.find('.notification-children .notice').length;
                if (selectedCount === childrenCount) {
                    const notificationParent = notificationGroup.find('.notification-parent');
                    notificationParent.find('.delete_button').hide();
                    notificationParent.find('.select-delete').show();
                    notificationParent.find('.select-delete input').prop('checked', true);
                }
            }

            updateSelectedCount();
        });

        $('.btn-refresh').on('click', function(event) {
            event.preventDefault();
            appn.location.reloadCurrentPage();
        });

        $('.btn-expand-boxes').on('click', function(event) {
            event.preventDefault();
            const iconClass = $('.card-btn-expand-or-collapse i');
            $('.notification-children').slideDown(0, function() {
                appn.ui.handleParentResize(0, 0);
            });
            iconClass.hasClass('fa-chevron-circle-down') ?
                iconClass.removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up') :
                iconClass.removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
        });

        $('.btn-collapse-boxes').on('click', function(event) {
            event.preventDefault();
            $('.notification-children').slideUp(0, function() {
                appn.ui.handleParentResize(0, 0);
            });
            const iconClass = $('.card-btn-expand-or-collapse i');
            iconClass.hasClass('fa-chevron-circle-down') ?
                iconClass.removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up') :
                iconClass.removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
        });

        $('.btn-goto').on('click', function (event) {
            event.preventDefault();
            window.open($(this).data('link'));
        });

        $('.btn-popup').on('click', function (event) {
            event.preventDefault();
            appn.ui.popup($(this).data('link'))
        });

        $('.dismiss-all').on('click', function(event) {
            event.preventDefault();
            $.ajax({
                headers: appn.verifyHeader,
                url: appn.urls.notifications.deleteAll,
                type: 'POST',
                data: { deleteAll: true },
                success: function(data, status, xhttp) {
                    (parent as any).appn.notifications.updateNotificationTotal(true);
                    (parent as any).appn.notifications.hideNotificationIcon();
                    appn.iframe.closeModal();
                },
                error: function(data, message, message2) {
                    appn.toast.notify(toast.Type.error, T('Delete all notifications failed!'));
                }
            });
        });

        $('.dismiss-forstatus').on('click', function(event) {
            event.preventDefault();
            const noticeStatus = $(this).data('status');

            $.ajax({
                headers: appn.verifyHeader,
                url: appn.urls.notifications.deleteAll,
                type: 'POST',
                data: { forstatus: noticeStatus },
                success: function(data, status, xhttp) {
                    $('.notice.notice-' + noticeStatus).remove();
                    $(this).remove();
                    updateSelectedCount();
                    cleanUpTabsAfterDelete();

                    (parent as any).appn.notifications.updateNotificationTotal(true);
                }
            });
        });

        $('.btn-downloadFile').on('click', function(event) {
            event.preventDefault();
            window.open($(this).data('link'));
        });

        $('.select-delete').on('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).closest('.card-tools').find('.delete_button').show();
            $(this).find('input').prop('checked', false);
            $(this).hide();

            const notificationParent = $(this).closest('.notification-group').find('.notification-parent');

            if (notificationParent.length > 0) {
                notificationParent.find('.delete_button').show();
                notificationParent.find('.select-delete input').prop('checked', false);
                notificationParent.find('.select-delete').hide();
            }

            if ($(this).closest('.notification-parent').length > 0) {
                $(this).closest('.notification-group').find('.notification-children .select-delete input').prop('checked', false);
                $(this).closest('.notification-group').find('.notification-children .select-delete').hide();
                $(this).closest('.notification-group').find('.notification-children .delete_button').show();
            }

            // Un-check tab box if any of the selected ones are deselected.
            const tabId = $(this).closest('.tab-pane').attr('id');
            const $tabSelect = $('.nav-tabs a[href="#' + tabId + '"]').closest('li').find('.tab-select');
            if (!$(this).prop('checked'))
                $tabSelect.prop('checked', false);

            updateSelectedCount();
        });

        $('.dismiss-selected').on('click', function(e) {
            e.preventDefault();

            // Build up a csv list of notice Id's to delete
            let selectedIdsCsv = '';
            $('.select-delete input:checked').each(function() {
                const $notice = $(this).closest('.notice');
                const noticeId = $notice.attr('id');

                // Create csv of ids to delete
                if (noticeId)
                    selectedIdsCsv += noticeId + ',';

                const notificationGroup = $notice.closest('.notification-group');
                // Remove the notice from the UI
                $notice.remove();

                notificationGroup.find('.children-count').html(notificationGroup.find('.notification-children .notice').length.toString());
            });

            // Send delete request to Server
            appn.notifications.deleteNotificationsCsv(selectedIdsCsv, cleanUpTabsAfterDelete);
            updateSelectedCount();
        });

        // Reschedule Notifications functions
        $('.reschedule-selected').on('click', function(e) {
            e.preventDefault();

            // Build up a csv list of notice Id's to reschedule
            let selectedIdsCsv = '';
            $('.select-reschedule input:checked').each(function() {
                const notice = $(this).closest('.notice');
                const noticeId = notice.attr('id');

                // Create csv of ids to reschedule
                if (noticeId)
                    selectedIdsCsv += noticeId + ',';

                const notificationGroup = notice.closest('.notification-group');
                // Remove the notice from the UI
                notice.remove();

                notificationGroup.find('.children-count').html(notificationGroup.find('.notification-children .notice').length.toString());
            });

            // Send reschedule request to Server
            appn.notifications.rescheduleNotificationsCsv(selectedIdsCsv, cleanUpTabsAfterDelete);
            updateSelectedCount();
        });

        $('.reschedule-all').on('click', function(event) {
            event.preventDefault();
            $.ajax({
                headers: appn.verifyHeader,
                url: appn.urls.notifications.rescheduleAll,
                type: 'POST',
                data: { rescheduleAll: true },
                success: function (data, status, xhttp) {
                    appn.location.reloadCurrentPage();
                },
                error: function(data, message, message2) {
                    appn.toast.notify(toast.Type.error, T('Reschedule all notifications failed!'));
                }
            });
        });

        $('.notification-group .notification-parent .card-title').off();

        $('.notification-parent').click(function(event) {
            event.preventDefault();
            event.stopPropagation();

            const iconClass = $(this).find('.card-btn-expand-or-collapse i');
            $(this).closest('.notification-group').find('.notification-children').stop().slideToggle(0, function() {
                appn.ui.handleParentResize(0, 0);
            });
            iconClass.hasClass('fa-chevron-circle-down') ?
                iconClass.removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up') :
                iconClass.removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
        });

        $('.nav-link .appn-checkbox').on('click', function (e) {
            e.preventDefault();

            const tabId = $(this).closest('li').find('.nav-link').attr('href');
            const input = $(this).find('.tab-select');

            // Check/un-check all check boxes in the selected tab
            const $allNoticeCheckboxesInCurrentTab = $(tabId + ' .select-delete');
            const $allNoticeDeleteBtnsInCurrentTab = $(tabId + ' .delete_button');

            if (!input.prop('checked')) {
                input.prop('checked', true);
                $allNoticeDeleteBtnsInCurrentTab.hide();
                $allNoticeCheckboxesInCurrentTab
                    .show();
                $allNoticeCheckboxesInCurrentTab
                    .find('input')
                    .prop('checked', true);
            } else {
                input.prop('checked', false);
                $allNoticeDeleteBtnsInCurrentTab.show();
                $allNoticeCheckboxesInCurrentTab
                    .hide();
                $allNoticeCheckboxesInCurrentTab
                    .find('input')
                    .prop('checked', false);
            }

            updateSelectedCount();
        });

        $('.nav-link').on('click', function (e) {
            // Only show Reschedule Button on Error tab
            const $rescheduleSelectedBtn = $('.reschedule-selected');
            if ($(this).hasClass('notice-tab-error')) {
                const rescheduleSelectedCount = $('.select-reschedule input:checked').length;
                if (rescheduleSelectedCount === 0)
                    $rescheduleSelectedBtn.hide();
                else
                    $rescheduleSelectedBtn.show();
            } else {
                // Only show when error tab is selected
                $('.reschedule-selected').hide();            
            }
        });
    }

    function hideNotificationFooterIfEmpty() {
        const $footerActionButtonLinks = $('.tab-pane .notice .card-footer .action-buttons');

        $footerActionButtonLinks.each(function() {
            // using trim as there is white space in the action button container
            if (!$.trim($(this).html()))
                $(this).closest('.card-footer').hideElement();
        });
    }

    function updateSelectedCount() {
        const dismissSelectedBtn = $('.dismiss-selected');
        const rescheduleSelectedBtn = $('.reschedule-selected');

        const notices = $('.notice');
        let totalDelete = 0;
        let totalReschedule = 0;

        notices.each((i, o) => {
            const notice = $(o);
            const parentClass = notice.parent().attr('class');
            if (parentClass === appn.emptyString || parentClass === 'notification-children') {
                totalDelete += notice.find('.select-delete input:checked').length;
                totalReschedule += notice.find('.select-reschedule input:checked').length;
            }
        });

        // Updates the 'Dismiss 123' button in the options menu
        dismissSelectedBtn.text(T(' Dismiss ') + totalDelete);
        dismissSelectedBtn.append('<i class="fa fa-trash ml-2"></i>');

        // Show/hide btn based on selection count.
        if (totalDelete === 0)
            dismissSelectedBtn.hide();
        else
            dismissSelectedBtn.show();

        // Updates the 'Reschedule 123' button in the options menu
        rescheduleSelectedBtn.text(T(' Reschedule ') + totalReschedule);
        rescheduleSelectedBtn.append('<i class="fa fa-calendar ml-2"></i>');

        // Show/hide btn based on selection count.
        if (totalReschedule === 0 || !$('.notice-tab-error').hasClass('active'))
            rescheduleSelectedBtn.hide();
        else
            rescheduleSelectedBtn.show();
    }

    function cleanUpTabsAfterDelete() {
        // Close notices if no more notices to show
        if ($('.notice').length === 0) {
            appn.notifications.hideNotificationIcon();
            appn.iframe.closeModal();
            return;
        }

        removeEmptyTabs();
    }

    function removeEmptyTabs() {
        // Remove the current empty tab and select a populated one
        const $tabPanes = $('.tab-pane');

        if ($tabPanes.length)
            $tabPanes.each(function(i, pane) {
                const tabId = $(pane).attr('id');
                if ($(pane).find('.notice').length === 0) {
                    $('.nav-tabs a[href="#' + tabId + '"]').closest('li').remove();

                    const tabs = $('.nav-tabs li .nav-link');
                    if (utils.hasValue(tabs))
                        tabs[0].click();
                }
            });
    }
}
